import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRouteAdmin = ({ children }) => {
  const { login, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  };

  if (!login) {
    return <Navigate to='/login' />;
  };

  if(login.role !== 'admin') {
    return <Navigate to='/login' />;
  };

  return children;
};

export const ProtectedRouteAuthor = ({ children }) => {
  const { login, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  };

  if (!login) {
    return <Navigate to='/autores/login' />;
  };

  if(login.role !== 'autor') {
    return <Navigate to='/autores/login' />;
  };

  return children;
};
